import {
  ADD_DOWNLOAD_SOFT,
  REMOVE_DOWNLOAD_SOFT,
  UPDATE_DOWNLOAD_SOFT_STATUS,
  UPDATE_DOWNLOAD_PROGRESS,
} from '../constants/download';
import { DOWNLOAD_FAILED, DOWNLOAD_ING } from '../constants/softstatus';

const initState = {
  softs: [],
};

const download = (state = initState, action = {}) => {
  let tmp;
  switch (action.type) {
    case ADD_DOWNLOAD_SOFT:
      // 去重
      tmp = state.softs.find(v => v.softID === action.soft.softID);
      if (tmp) {
        if (tmp.status === DOWNLOAD_FAILED) {
          tmp.status = DOWNLOAD_ING;
          tmp.DownloadSpeed = 0;
          tmp.AverageDownloadSpeed = 0;
          tmp.progress = 0;
          return { ...state, softs: [...state.softs] };
        }
        return state;
      }
      return { ...state, softs: [...state.softs, action.soft] };

    case REMOVE_DOWNLOAD_SOFT:
      tmp = state.softs.filter(v => v.softID !== action.softID);
      return { ...state, softs: tmp };
    case UPDATE_DOWNLOAD_PROGRESS:
      state.softs.some(v => {
        if (v.softID === action.SoftID) {
          const tmpObj = v;
          tmpObj.DownloadSpeed = action.DownloadSpeed || 0;
          tmpObj.AverageDownloadSpeed = action.AverageDownloadSpeed || 0;
          tmpObj.progress = action.progress;
          return true;
        }
        return false;
      });
      return { ...state, softs: [...state.softs] };
    case UPDATE_DOWNLOAD_SOFT_STATUS:
      state.softs.some(v => {
        if (v.softID === action.SoftID) {
          const tmpObj = v;
          tmpObj.status = action.status;
          tmpObj.averagespeed = action.averagespeed;
          tmpObj.taskid = action.taskid;
          tmpObj.mes = action.mes;
          tmpObj.code = action.code;
          return true;
        }
        return false;
      });
      return { ...state, softs: [...state.softs] };

    default:
      return state;
  }
};

export default download;
